export const SESSION_STORAGE_KEYS = {
  localDevExperiments: 'localDevExperiments',
};
